import { createApi } from '@reduxjs/toolkit/query/react'

import { getQueryUsuarioVistaModulosByEmail } from '../constants/queryUsuarioVistaModulos'
import {
  urlUsuarioVistaModuloParaActualizar,
  urlUsuarioVistaModuloParaEliminar,
  urlUsuarioVistaModulos,
} from '../constants/urlUsuarioVistaModulos'

import { UsuarioVistaModuloRequest } from '../interfaces/UsuarioVistaModulos'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'
import { UsuarioVistaModulo } from '@/core/odata/interfaces/MtPerseveranceBackendApiRepositoriesModel'

export interface CartaReservaQuery {
  ReservaCentralizadaId: number
  ConfiguracionReserva: {
    ConfiguracionReservaId: number
    CartaNuevaReserva: string
    CartaModificacionReserva: string
    CartaCancelacionReserva: string
    CartaRoomingListReserva: string
  }
}

export const userConfigurationApi = createApi({
  reducerPath: 'userConfigurationApi',
  baseQuery,
  endpoints: (builder) => ({
    getUserConfiguration: builder.query<
      GenericResponseOData<UsuarioVistaModulo[]>,
      { email: string }
    >({
      query: ({ email }) => ({
        url: `${urlUsuarioVistaModulos()}?${getQueryUsuarioVistaModulosByEmail(email)}`,
        method: 'GET',
      }),
    }),
    createUserConfiguration: builder.mutation<
      UsuarioVistaModulo,
      UsuarioVistaModuloRequest
    >({
      query: (values) => ({
        url: urlUsuarioVistaModulos(),
        method: 'POST',
        body: values,
      }),
    }),
    updatedUserConfiguration: builder.mutation<
      UsuarioVistaModulo,
      Partial<UsuarioVistaModulo>
    >({
      query: (values) => ({
        url: urlUsuarioVistaModuloParaActualizar(values.UsuarioVistaModuloId),
        method: 'PUT',
        body: values,
      }),
    }),
    deleteUserConfiguration: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: urlUsuarioVistaModuloParaEliminar(id),
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useLazyGetUserConfigurationQuery,
  useUpdatedUserConfigurationMutation,
  useDeleteUserConfigurationMutation,
  useCreateUserConfigurationMutation,
  usePrefetch,
} = userConfigurationApi
